<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="众筹ID" :value="1"></el-option>
                            <el-option label="众筹名称" :value="2"></el-option>
                            <!--<el-option label="订单ID" :value="3"></el-option>-->
                            <el-option label="订单编号" :value="4"></el-option>
                            <el-option label="购买人ID" :value="5"></el-option>
                            <el-option label="联系人手机号码" :value="6"></el-option>
                            <!-- <el-option label="观演人姓名" :value="7"></el-option> -->
                            <!-- <el-option label="外部渠道订单编号" :value="8"></el-option> -->
                            <el-option label="支付平台交易号" :value="9"></el-option>
                            <el-option label="运单号" :value="10"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.paymentStatus" placeholder="请选择" size="small">
                        <el-option label="不限制支付状态" value=""></el-option>
                        <el-option label="仅看未支付的" :value="1"></el-option>
                        <el-option label="仅看已支付的" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.orderStatus" placeholder="请选择" size="small">
                        <el-option label="不限制订单状态" value=""></el-option>
                        <el-option label="仅看待支付的" :value="1"></el-option>
                        <el-option label="仅看待发货的" :value="2"></el-option>
                        <el-option label="仅看已发货的" :value="4"></el-option>
                        <el-option label="仅看已完成的" :value="5"></el-option>
                        <el-option label="仅看已过期的" :value="6"></el-option>
                        <el-option label="仅看已取消的" :value="7"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.skuType" placeholder="请选择" size="small">
                        <el-option label="不限制发货方式" value=""></el-option>
                        <el-option label="仅看网络发送的" :value="7"></el-option>
                        <el-option label="仅看国内包邮的" :value="8"></el-option>
                        <el-option label="仅看无需发货的" :value="9"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.dateType" slot="prepend" placeholder="请选择">
                                <el-option label="下单时间" :value="1"></el-option>
                                <el-option label="退款时间" :value="2"></el-option>
                                <el-option label="支付时间" :value="3"></el-option>
                                <el-option label="取消时间" :value="4"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/raise/order/export')" type="primary" icon="el-icon-download" size="small" @click="download" :loading="downLoading">导出订单</el-button>
            <el-button v-if="$utils.have('/raise/order/batchImport')"  type="primary" icon="el-icon-position" size="small" @click="$refs.batchDeliver.show()">批量发货</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="paymentStatus" label="支付状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.paymentStatus == 1">未支付</span>
                        <span v-else-if="scope.row.paymentStatus == 2" class="color-success">已支付</span>
                    </template>
                </el-table-column>
                <el-table-column prop="orderStatus" label="订单状态">
                    <template slot-scope="scope">
                       {{orderStatus.get(scope.row.orderStatus)}}
                    </template>
                </el-table-column>
                <!--<el-table-column prop="id" label="订单ID"></el-table-column>-->
                <el-table-column prop="sn" label="订单编号" min-width="140"></el-table-column>
                <el-table-column prop="outTradeNo" label="支付平台交易号" min-width="250"></el-table-column>
                <el-table-column prop="rewards" label="回报项" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="payNum" label="支持份数"></el-table-column>
                <el-table-column prop="totalAmountStr" label="总价"></el-table-column>
                <el-table-column prop="realPayAmountStr" label="实际支付"></el-table-column>
                <el-table-column prop="createUser" label="购买人ID"></el-table-column>
                <el-table-column prop="telephone" label="联系手机" min-width="130">
                    <template slot-scope="scope">
                        {{scope.row.areaCode && scope.row.telephone ? '+'+scope.row.areaCode.split('_')[0] : ''}} {{scope.row.telephone}}
                    </template>
                </el-table-column>
                <el-table-column prop="terminal" label="下单终端" min-width="90"></el-table-column>
                <el-table-column prop="payPlatformName" label="支付渠道" min-width="130"></el-table-column>
                <el-table-column prop="goodId" label="众筹ID"></el-table-column>
                <el-table-column prop="goodName" label="众筹名称" show-overflow-tooltip min-width="250">
                    <template slot-scope="scope">
                        {{scope.row.goodName}}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="下单时间" min-width="150"></el-table-column>
                <el-table-column prop="payTime" label="支付时间" min-width="150"></el-table-column>
                <el-table-column prop="cancelTime" label="取消时间" min-width="150"></el-table-column>
                <el-table-column prop="refundTime" label="退款时间" min-width="150"></el-table-column>
                <el-table-column prop="deliveryTypes" label="发货方式"></el-table-column>
                <el-table-column prop="address" label="收货邮箱" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.cityName ? '' : scope.row.address}}
                    </template>
                </el-table-column>
                <el-table-column prop="customerName" label="收货人" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="provinceName" label="收货省份"></el-table-column>
                <el-table-column prop="cityName" label="收货城市"></el-table-column>
                <el-table-column prop="address" label="收货地址" show-overflow-tooltip min-width="160">
                    <template slot-scope="scope">
                        {{scope.row.cityName ? scope.row.address : ''}}
                    </template>
                </el-table-column>
                <el-table-column prop="expressName" label="快递公司" show-overflow-tooltip></el-table-column>
                <el-table-column prop="expressNo" label="运单号" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="70">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/raise/order/detail')"
                            type="text"
                            size="small"
                            icon="el-icon-s-management"
                            @click="edit(scope.row.id)"
                            >管理</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <BatchDeliver ref="batchDeliver" @onUpdate="getDataList"></BatchDeliver>
    </div>
</template>

<script>
import BatchDeliver from './components/batchDeliver';
const defaultParams = {
    pageNo:1,
    searchType: 1,
    searchValue: '',
    dateType: 1,
    startTime: '',
    endTime: '',
    paymentStatus: '',
    orderStatus: '',
    skuType: '',
}
export default {
    components:{BatchDeliver},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                dateType: parseInt(this.$route.query.dateType || 1),
                startTime:this.$route.query.startTime || '',
                endTime:this.$route.query.endTime || '',
                paymentStatus: this.$route.query.paymentStatus ? parseInt(this.$route.query.paymentStatus) : '',
                orderStatus: this.$route.query.orderStatus ? parseInt(this.$route.query.orderStatus) : '',
                skuType: this.$route.query.skuType ? parseInt(this.$route.query.skuType) : '',
            },
            datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            listLoading: true,
            downLoading: false
        }
    },
    computed:{
        orderStatus(){
            return new Map([
                [1,'待支付'],
                [2,'待发货'],
                [3,'部分发货'],
                [4,'已发货'],
                [5,'已完成'],
                [6,'已过期'],
                [7,'已取消'],
            ])
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                startTime:this.datetimerange && this.datetimerange[0] || '',
                endTime:this.datetimerange && this.datetimerange[1] || ''
            }
            this.$request({
                url: "/raise/order/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //导出订单
        async download(){
            this.downLoading = true;
            this.$request({
                url:"/raise/order/export",
                method: "POST",
                data: this.params ,
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1 ) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({path:'/workbench/downloadList'})
                        }).catch(() => {})
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
        //编辑事件
        edit(id){
            this.$router.push({
                path: `/raise/order/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
    }    
}
</script>